"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "Hoe lang duurt het traject van ontwerp tot lancering?",
  answer: "Bij North Websites streven we naar snelheid zonder kwaliteitsverlies. Gemiddeld staat een professionele website binnen 4 tot 6 weken live. Dit is inclusief de strategische fase, het unieke design en de technische realisatie."
}, {
  question: "Zijn de websites geoptimaliseerd voor zoekmachines (SEO)?",
  answer: "Absoluut. Wij bouwen elke website met een 'search-first' mindset. Dit betekent schone code, razendsnelle laadtijden, mobiele optimalisatie en een logische structuur die zoekmachines zoals Google waarderen."
}, {
  question: "Kan ik mijn website later zelf eenvoudig aanpassen?",
  answer: "Zeker! Wij maken gebruik van intuïtieve beheersystemen. Je ontvangt van ons een korte training zodat je zonder technische kennis zelf teksten kunt wijzigen, afbeeldingen kunt uploaden en nieuwe blogberichten kunt plaatsen."
}, {
  question: "Bieden jullie ook hosting en technisch onderhoud aan?",
  answer: "Ja, wij ontzorgen je volledig. We bieden ultra-snelle hosting, beveiligde SSL-certificaten en regelmatige software-updates. Zo blijft jouw digitale visitekaartje altijd veilig, up-to-date en optimaal presterend."
}, {
  question: "Is mijn website direct geschikt voor mobiel en tablet?",
  answer: "In de huidige mobiele wereld is responsiviteit geen optie maar een vereiste. Jouw website schaalt naadloos mee met elk schermformaat, van smartphone tot breedbeeldmonitor, voor een perfecte gebruikerservaring."
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="78748" id="veelgestelde-vragen" className="dark bg-background py-24 px-4">
      <div ref={ref} className={`max-w-3xl mx-auto transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-foreground mb-4">
            Veelgestelde Vragen
          </h2>
          <p className="text-muted-foreground text-lg font-sans">
            Alles wat je moet weten over het laten bouwen van je nieuwe digitale platform door North Websites.
          </p>
        </div>

        <div className="bg-card/40 backdrop-blur-xl rounded-2xl shadow-2xl border border-white/10 p-2 md:p-6">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-white/5">
                <AccordionTrigger className="text-primary font-bold text-lg md:text-xl hover:no-underline hover:text-secondary transition-colors text-left px-4 tracking-tight">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed px-4 pb-6 text-base font-sans">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}